"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultedSubPropertiesRule = void 0;
var rule_1 = require("./rule");
var DefaultedSubPropertiesRule = /** @class */ (function (_super) {
    __extends(DefaultedSubPropertiesRule, _super);
    function DefaultedSubPropertiesRule(rootType, name, options) {
        var _this = this;
        if (!options.property)
            throw new Error("property is required");
        if (!options.defaults)
            throw new Error("defaults is required");
        var ruleName = name || rootType.fullName + "." + options.property.name + ".DefaultedSubProperties";
        _this = _super.call(this, rootType, ruleName, options) || this;
        _this.property = options.property;
        _this.defaults = options.defaults;
        return _this;
    }
    DefaultedSubPropertiesRule.prototype.execute = function (obj) {
        var parentValue = this.property.value(obj);
        if (!parentValue)
            return;
        // Collect all sub-property updates first
        var updates = {};
        for (var _i = 0, _a = this.defaults; _i < _a.length; _i++) {
            var def = _a[_i];
            var result = def.function.call(obj);
            if (result && typeof result === "object") {
                for (var _b = 0, _c = Object.entries(result); _b < _c.length; _b++) {
                    var _d = _c[_b], key = _d[0], value = _d[1];
                    // Clear empty strings before setting value
                    if (value === "")
                        value = null;
                    updates[key] = value;
                }
            }
        }
        // Apply all updates to the parentValue
        Object.assign(parentValue, updates);
    };
    DefaultedSubPropertiesRule.prototype.toString = function () {
        return "defaulted subproperties of " + this.property.name;
    };
    return DefaultedSubPropertiesRule;
}(rule_1.Rule));
exports.DefaultedSubPropertiesRule = DefaultedSubPropertiesRule;
